import {AccountDetails, AccountType} from "./account";
import {Asset} from "./asset";

export interface ListLandlordsProjection
{
    id: string
    name: string
    surname: string
}

export interface Landlord extends LandlordDetails
{
    hibernateLazyInitializer: any
}

export interface LandlordDetails {
    account: LandlordAccount
    category: LandlordCategory
    id: string
    logo: string
}

export enum LandlordCategory
{
    OWNER = "OWNER",
    PRIVATE_SUBTENANT = "PRIVATE_SUBTENANT",
    COMPANY_SUBTENANT = "COMPANY_SUBTENANT",
    ESTATE_AGENCY = "ESTATE_AGENCY",
    DEVELOPMENT_COMPANY = "DEVELOPMENT_COMPANY",
    BANK = "BANK",
    ESTATE_FUND = "ESTATE_FUND",
    ASSOCIATION = "ASSOCIATION",
    PUBLIC_AUTHORITY = "PUBLIC_AUTHORITY",
}

interface LandlordAccount {
    accountDetails: AccountDetails
    accountLikesAssets: Asset[]
    accountType: AccountType
    creationDate: Date
    disabled: boolean
    id: string
    lastLogin: Date
    username: string
}

export interface CreateLandlordAccountRequest {
    username: string
    firstName: string
    lastName?: string
    address?: string | null
    city?: string | null
    province?: string | null
    postalCode?: string | null
    country?: string | null
    phone?: string | null
    vatCode?: string | null
    fiscalCode?: string | null
}

export interface CreateLandlordRequest {
    category: LandlordCategory
    logo?: string | null
    accountId?: string
    account?: CreateLandlordAccountRequest
    sendWelcomeEmail?: boolean
}

export interface CreateLandlordResponse {
    id: string
}
